/**
 * take 2 arrays that have the key of id an return an array that has no common objects
 * Handy for lists that don't require object that have already been selected.
 * @param {*} array1 - one array of objects
 * @param {*} array2 - another array of objects
 */
export const uniqueSymmetricDifference = (array1, array2) => {
    if (Array.isArray(array1) && !Array.isArray(array2)) {
        return array1;
    }
    if (!Array.isArray(array1) && Array.isArray(array2)) {
        return array2;
    }
    if (Array.isArray(array1) && Array.isArray(array2)) {
        return [
            ...array1.filter(v => !array2.some(entry => entry.id === v.id)),
            ...array2.filter(v => !array1.some(entry => entry.id == v.id))
        ];
    }
    return [];
};

/**
 * All array A items will end up in the result. array b items - Only NON duplicates from array A will be added using the comparator
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator to match items from array A with Array B
 */
export const unionWith = (a, b, comp) => {
    return Array.from(new Set([...a, ...b.filter(x => a.findIndex(y => comp(x, y)) === -1)]));
};

/**
 * Returns items from array A that ARE NOT in array B (NOTE - If items from B are not in A - they will not be in the result)
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator that finds the difference in the 2 arrays
 */
export const differenceBy = (a, b, fn) => {
    const s = new Set(b.map(fn));
    return a.filter(x => !s.has(fn(x)));
};

/**
 * Wrapper for differenceBy that uses the object id as the comparator
 * @param {*} a 
 * @param {*} b 
 */
export const differenceById = (a, b) => {
    return differenceBy(a, b, v => v.id);
};

/**
 * Returns items from array A that ARE NOT in array B (NOTE - If items from B are not in A - they will not be in the result)
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator that finds the difference in the 2 arrays
 */
export const sameBy = (a, b, comp) => {
    const s = new Set(b);
    return a.filter(x => s.has(comp(x)));
};

/**
 * Wrapper for differenceBy that uses the object id as the comparator
 * @param {Array} a objects that have an id field [{id: 'id1'}, {id: 'id3'}]
 * @param {Array} b Array of value that contain the id value to lookup ['id1', 'id2']
 */
export const sameByIdValue = (a, b) => {
    return sameBy(a, b, v => v.id);
};

/**
 * update the entry in the list based on the id of the object
 * @param {*} list the list to update
 * @param {*} payload the payload to add or update
 */
export const addOrUpdateEntry = (list, payload) => {
    let isNew = true;
    if (Array.isArray(list) && payload) {
        const updatedList = list.map((entry) => {
            if (entry.id === payload.id) {
                // have a match in the list so return the new entry replacing the old one
                isNew = false;
                return payload;
            } else {
                // not a match so simply return the current entry
                return entry;
            }
        });
        // if the payload is not in the list then add it before returning the updated list
        if (isNew) {
            updatedList.push(payload);
        }
        return updatedList;
    }
    return list;
};


export const uniqByKeepFirst = (a, key) => {
    let seen = new Set();
    return a.filter(item => {
        let k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
};


export const uniqByKeepLast = (a, key) => {
    return [
        ...new Map(
            a.map(x => [key(x), x])
        ).values()
    ];
};

const containsById = (array, obj) => {
    for (var i = 0; i < array.length; i++) {
        if (isEqualById(array[i], obj)) return true;
    }
    return false;
};

//comparator
const isEqualById = (obj1, obj2) => {
    if (obj1.id == obj2.id) return true;
    return false;
};

export const removeDuplicatesById = (array) => {
    var temp = [];
    return array.filter(entry => !containsById(temp, entry) && temp.push(entry));
};



// WEBPACK FOOTER //
// ./services/arrayService.js